module.exports = __webpack_public_path__ + "img/Carrousels STARTO – après rdv_slide_4.5d87f290.png";